import { render, staticRenderFns } from "./PengajuanLanjutan.vue?vue&type=template&id=9b46c618&"
import script from "./PengajuanLanjutan.vue?vue&type=script&lang=js&"
export * from "./PengajuanLanjutan.vue?vue&type=script&lang=js&"
import style0 from "./PengajuanLanjutan.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports